import axios from "axios";
import { createContext, useContext, useReducer, useEffect } from "react";
import Home_reducer from "../reducer/Home_reducer";
import {
  GET_CURRENT_EXPO_BEGIN,
  GET_CURRENT_EXPO_ERROR,
  GET_CURRENT_EXPO_SUCCESS,
  GET_CURTAIN_RAISER_CATEGORY_BEGIN,
  GET_CURTAIN_RAISER_CATEGORY_SUCCESS,
  GET_CURTAIN_RAISER_CATEGORY_ERROR,
  GET_CURTAIN_RAISER_BEGIN,
  GET_CURTAIN_RAISER_SUCCESS,
  GET_CURTAIN_RAISER_ERROR,
  GET_VOICE_CATEGORY_BEGIN,
  GET_VOICE_CATEGORY_SUCCESS,
  GET_VOICE_CATEGORY_ERROR,
  GET_VOICE_BEGIN,
  GET_VOICE_SUCCESS,
  GET_VOICE_ERROR,
  GET_SPONSER_CATEGORY_BEGIN,
  GET_SPONSER_CATEGORY_SUCCESS,
  GET_SPONSER_CATEGORY_ERROR,
  GET_CURRENT_CONTACT_BEGIN,
  GET_CURRENT_CONTACT_SUCCESS,
  GET_CURRENT_CONTACT_ERROR,
  GET_EDITION_EXPO_BEGIN,
  GET_EDITION_EXPO_SUCCESS,
  GET_EDITION_EXPO_ERROR,
  GET_EDITION_CATEGORY_BEGIN,
  GET_EDITION_CATEGORY_SUCCESS,
  GET_EDITION_CATEGORY_ERROR,
} from "../utils/action";
import {
  ACCEPT_HEADER,
  get_current_expo_url,
  get_curtain_raiser_category_url,
  get_curtain_raiser_url,
  get_voice_category_url,
  get_voice_url,
  get_sponser_category_url,
  get_current_contact_url,
  get_edition_expo_url,
  get_edition_category_url,
} from "../utils/constant";

const HomeContext = createContext();

const initialState = {
  current_expo_loading: false,
  current_expo_data: {},
  edition_expo_loading: false,
  edition_expo_data: {},
  edition_category_loading: false,
  edition_category_data: [],
  curtain_raiser_category_loading: false,
  curtain_raiser_category_data: [],
  curtain_raiser_loading: false,
  curtain_raiser_data: [],
  voice_category_loading: false,
  voice_category_data: [],
  voice_loading: false,
  voice_data: [],
  sponser_category_loading: false,
  sponser_category_data: [],
  current_contact_loading: false,
  current_contact_data: {},
};

export const HomeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Home_reducer, initialState);

  // ─── GET CURRENT EXPO ───────────────────────────────────────────────────────
  const GetCurrentExpo = async () => {
    dispatch({ type: GET_CURRENT_EXPO_BEGIN });

    axios
      .get(get_current_expo_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_CURRENT_EXPO_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_CURRENT_EXPO_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Current Expo Api ", err);
        dispatch({ type: GET_CURRENT_EXPO_ERROR });
      });
  };

  // ─── GET EDITION EXPO ───────────────────────────────────────────────────────
  const GetEditionExpo = async (categoryId) => {
    dispatch({ type: GET_EDITION_EXPO_BEGIN });

    const formdata = new FormData();
    if (categoryId !== undefined && categoryId !== null) {
      formdata.append("edition_category_id", categoryId);
    }

    axios
      .post(get_edition_expo_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_EDITION_EXPO_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_EDITION_EXPO_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Edition Expo Api ", err);
        dispatch({ type: GET_EDITION_EXPO_ERROR });
      });
  };

  // ─── GET EDITION CATEGORY ───────────────────────────────────────────────────
  const GetEditionCategory = async () => {
    dispatch({ type: GET_EDITION_CATEGORY_BEGIN });

    axios
      .get(get_edition_category_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_EDITION_CATEGORY_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_EDITION_CATEGORY_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Edition Category Api ", err);
        dispatch({ type: GET_EDITION_CATEGORY_ERROR });
      });
  };

  // ─── GET CURTAIN RAISER CATEGORY ───────────────────────────────────────────
  const GetCurtainRaiserCategory = async () => {
    dispatch({ type: GET_CURTAIN_RAISER_CATEGORY_BEGIN });

    axios
      .get(get_curtain_raiser_category_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_CURTAIN_RAISER_CATEGORY_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_CURTAIN_RAISER_CATEGORY_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Curtain Raiser Category Api ", err);
        dispatch({ type: GET_CURTAIN_RAISER_CATEGORY_ERROR });
      });
  };

  // ─── GET CURTAIN RAISER (POST with curtain_raiser_category_id) ─────────────
  const GetCurtainRaiser = async (categoryId) => {
    dispatch({ type: GET_CURTAIN_RAISER_BEGIN });

    const formdata = new FormData();
    if (categoryId !== undefined && categoryId !== null) {
      formdata.append("curtain_raiser_category_id", categoryId);
    }

    axios
      .post(get_curtain_raiser_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_CURTAIN_RAISER_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_CURTAIN_RAISER_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Curtain Raiser Api ", err);
        dispatch({ type: GET_CURTAIN_RAISER_ERROR });
      });
  };

  // ─── GET VOICE CATEGORY ───────────────────────────────────────────────────
  const GetVoiceCategory = async () => {
    dispatch({ type: GET_VOICE_CATEGORY_BEGIN });

    axios
      .get(get_voice_category_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_VOICE_CATEGORY_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_VOICE_CATEGORY_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Voice Category Api ", err);
        dispatch({ type: GET_VOICE_CATEGORY_ERROR });
      });
  };

  // ─── GET VOICE (POST with voice_category_id) ──────────────────────────────
  const GetVoice = async (categoryId) => {
    dispatch({ type: GET_VOICE_BEGIN });

    const formdata = new FormData();
    if (categoryId !== undefined && categoryId !== null) {
      formdata.append("voice_category_id", categoryId);
    }

    axios
      .post(get_voice_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_VOICE_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_VOICE_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Voice Api ", err);
        dispatch({ type: GET_VOICE_ERROR });
      });
  };

  // ─── GET SPONSER CATEGORY ──────────────────────────────────────────────────
  const GetSponserCategory = async () => {
    dispatch({ type: GET_SPONSER_CATEGORY_BEGIN });

    axios
      .get(get_sponser_category_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_SPONSER_CATEGORY_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_SPONSER_CATEGORY_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Sponser Category Api ", err);
        dispatch({ type: GET_SPONSER_CATEGORY_ERROR });
      });
  };

  // ─── GET CURRENT CONTACT ───────────────────────────────────────────────────
  const GetCurrentContact = async () => {
    dispatch({ type: GET_CURRENT_CONTACT_BEGIN });

    axios
      .get(get_current_contact_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({
            type: GET_CURRENT_CONTACT_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_CURRENT_CONTACT_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Current Contact Api ", err);
        dispatch({ type: GET_CURRENT_CONTACT_ERROR });
      });
  };

  // Automatically fetch initial data once when the provider mounts
  useEffect(() => {
    GetCurrentExpo();
    GetCurtainRaiserCategory();
    GetVoiceCategory();
    GetSponserCategory();
    GetCurrentContact();
  }, []);

  return (
    <HomeContext.Provider
      value={{
        ...state,
        GetCurrentExpo,
        GetEditionExpo,
        GetEditionCategory,
        GetCurtainRaiserCategory,
        GetCurtainRaiser,
        GetVoiceCategory,
        GetVoice,
        GetSponserCategory,
        GetCurrentContact,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export const useHomeContext = () => {
  return useContext(HomeContext);
};
